import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import data from "./data.json";

const DepositEntryForm = () => {
  const { header, form, tables, buttons, colors } = data;
  const [formData, setFormData] = useState({});
  const [leftTableData, setLeftTableData] = useState([]);
  const [rightTableData, setRightTableData] = useState([]);
  const navigate = useNavigate();

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleButtonClick = (id) => {
    if (id === "saveEntry") {
      const newLeftRow = {
        by: formData.byPerson || "",
        depositDate: formData.depositDate || "",
        amount: formData.depositAmount || "",
      };

      const newRightRow = {
        billDate: formData.depositDate || "",
        billNo: formData.partyCode || "",
        commission: "0",
        amount: formData.depositAmount || "",
        netAmount: formData.totalAmount || "",
      };

      setLeftTableData((prev) => [...prev, newLeftRow]);
      setRightTableData((prev) => [...prev, newRightRow]);
      setFormData({});
    } else if (id === "returnMain") {
      navigate("/dashboard");
    } else if (id === "deleteEntry") {
      setLeftTableData([]);
      setRightTableData([]);
      setFormData({});
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col items-center p-2 sm:p-4 bg-red-100 lg:justify-center"
    >
      <div className="text-center text-xs sm:text-sm mb-1 sm:mb-2">
        {header.softwareInfo}
      </div>
      <div className="text-center text-lg sm:text-xl font-bold text-brown-800">
        {header.title}
      </div>
      <div className="text-center mb-3 sm:mb-4 text-brown-700 text-sm sm:text-base">
        {header.subtitle}
      </div>

      <div
        className="border rounded-2xl p-3 sm:p-4 w-full max-w-6xl flex flex-col lg:flex-row justify-around gap-3"
        style={{
          backgroundColor: colors.panel,
          borderColor: colors.border,
          borderWidth: 1,
        }}
      >
        <div className="flex flex-col justify-between w-full lg:w-1/3 gap-3">
          <div className="border border-black p-2 rounded-md">
            {form.fields.slice(0, 3).map((field, index) => (
              <div
                key={index}
                className="flex flex-wrap items-center justify-between mb-1"
              >
                <label className="text-sm w-1/2">{field.label}:</label>
                {field.type === "select" ? (
                  <select
                    id={field.id}
                    name={field.id}
                    value={formData[field.id] || ""}
                    onChange={handleChange}
                    className="w-1/2 border rounded px-1 text-sm"
                    style={{ backgroundColor: colors.inputBackground }}
                  >
                    <option value="">Select</option>
                  </select>
                ) : (
                  <input
                    type={field.type}
                    id={field.id}
                    name={field.id}
                    value={formData[field.id] || ""}
                    onChange={handleChange}
                    className="w-1/2 border rounded px-1 text-sm"
                    style={{ backgroundColor: colors.inputBackground }}
                  />
                )}
              </div>
            ))}
          </div>

          <div className="border border-black p-2 rounded-md">
            {form.fields.slice(3, 6).map((field, index) => (
              <div
                key={index}
                className="flex flex-wrap items-center justify-between mb-1"
              >
                <label className="text-sm w-1/2">{field.label}:</label>
                <input
                  type="text"
                  id={field.id}
                  name={field.id}
                  value={formData[field.id] || ""}
                  onChange={handleChange}
                  className="w-1/2 border rounded px-1 text-sm"
                  style={{ backgroundColor: colors.inputBackground }}
                />
              </div>
            ))}
          </div>

          <div className="border border-black p-2 rounded-md">
            <div className="text-sm font-semibold mt-1">
              {form.fields[6].label}:
              <span className="float-end">{form.fields[6].value}</span>
            </div>

            {form.fields.slice(7, 9).map((field, index) => (
              <div
                key={index}
                className="flex flex-wrap items-center justify-between mb-1"
              >
                <label className="text-sm w-1/2">{field.label}:</label>
                <input
                  type="text"
                  id={field.id}
                  name={field.id}
                  value={formData[field.id] || ""}
                  onChange={handleChange}
                  className="w-1/2 border rounded px-1 text-sm"
                  style={{ backgroundColor: colors.inputBackground }}
                />
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col gap-3 w-full lg:w-2/3">
          <div className="border h-40 sm:h-44 overflow-auto bg-white rounded-md">
            <table className="w-full text-xs text-center border-collapse">
              <thead>
                <tr className="bg-gray-200">
                  {tables.leftTable.headers.map((h, i) => (
                    <th key={i} className="border p-1">
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {leftTableData.length === 0 ? (
                  <tr>
                    <td
                      colSpan={tables.leftTable.headers.length}
                      className="border p-1 text-gray-500"
                    >
                      No entries
                    </td>
                  </tr>
                ) : (
                  leftTableData.map((row, i) => (
                    <tr key={i}>
                      <td className="border p-1">{row.by}</td>
                      <td className="border p-1">{row.depositDate}</td>
                      <td className="border p-1">{row.amount}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          <div className="border h-40 sm:h-44 overflow-auto bg-white rounded-md">
            <table className="w-full text-xs text-center border-collapse">
              <thead>
                <tr className="bg-gray-200">
                  {tables.rightTable.headers.map((h, i) => (
                    <th key={i} className="border p-1">
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rightTableData.length === 0 ? (
                  <tr>
                    <td
                      colSpan={tables.rightTable.headers.length}
                      className="border p-1 text-gray-500"
                    >
                      No entries
                    </td>
                  </tr>
                ) : (
                  rightTableData.map((row, i) => (
                    <tr key={i}>
                      <td className="border p-1">{row.billDate}</td>
                      <td className="border p-1">{row.billNo}</td>
                      <td className="border p-1">{row.commission}</td>
                      <td className="border p-1">{row.amount}</td>
                      <td className="border p-1">{row.netAmount}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap justify-center mt-4 gap-2">
        {buttons.map((btn, i) => (
          <button
            key={i}
            onClick={() => handleButtonClick(btn.id)}
            className="border px-3 py-1 rounded-md text-sm shadow-sm bg-gray-300 border-black hover:bg-gray-400"
          >
            {btn.label}
          </button>
        ))}
      </div>
    </div>
  );
};


export default DepositEntryForm;
